import { MatchOperator } from "../../model/model"
import ObjectUtil from "../../util/ObjectUtil"
import ValueMatcher from "./ValueMatcher"

export default interface OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean
}

export class InMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.inMatches(userValue, matchValue))
  }
}

export class ContainsMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.containsMatches(userValue, matchValue))
  }
}

export class StartsWithMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.startsWithMatches(userValue, matchValue))
  }
}

export class EndsWithMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.endsWithMatches(userValue, matchValue))
  }
}

export class GreaterThanMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.greaterThanMatches(userValue, matchValue))
  }
}

export class GreaterThanOrEqualToMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.greaterThanOrEqualMatches(userValue, matchValue))
  }
}

export class LessThanMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.lessThanMatches(userValue, matchValue))
  }
}

export class LessThanOrEqualToMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    if (ObjectUtil.isNullOrUndefined(userValue)) return false
    return matchValues.some((matchValue) => valueMatcher.lessThanOrEqualMatches(userValue, matchValue))
  }
}

export class ExistsMatcher implements OperatorMatcher {
  matches(valueMatcher: ValueMatcher, userValue: any, matchValues: any[]): boolean {
    return !ObjectUtil.isNullOrUndefined(userValue)
  }
}

export class OperatorMatcherFactory {
  private static IN_MATCHER = new InMatcher()
  private static CONTAINS_MATCHER = new ContainsMatcher()
  private static STARTS_WITH_MATCHER = new StartsWithMatcher()
  private static ENDS_WITH_MATCHER = new EndsWithMatcher()
  private static GT_MATCHER = new GreaterThanMatcher()
  private static GTE_MATCHER = new GreaterThanOrEqualToMatcher()
  private static LT_MATCHER = new LessThanMatcher()
  private static LTE_MATCHER = new LessThanOrEqualToMatcher()
  private static EXISTS_MATCHER = new ExistsMatcher()

  getMatcher(operator: MatchOperator): OperatorMatcher {
    switch (operator) {
      case "IN":
        return OperatorMatcherFactory.IN_MATCHER
      case "CONTAINS":
        return OperatorMatcherFactory.CONTAINS_MATCHER
      case "STARTS_WITH":
        return OperatorMatcherFactory.STARTS_WITH_MATCHER
      case "ENDS_WITH":
        return OperatorMatcherFactory.ENDS_WITH_MATCHER
      case "GT":
        return OperatorMatcherFactory.GT_MATCHER
      case "GTE":
        return OperatorMatcherFactory.GTE_MATCHER
      case "LT":
        return OperatorMatcherFactory.LT_MATCHER
      case "LTE":
        return OperatorMatcherFactory.LTE_MATCHER
      case "EXISTS":
        return OperatorMatcherFactory.EXISTS_MATCHER
    }
  }
}
